// extracted by mini-css-extract-plugin
export default {"main_page":"Main_main_page__c16r2","statistics":"Main_statistics__vnf4q"};